import { all, call, /*  call, */ fork, put, takeLatest } from 'redux-saga/effects'
import store from 'store'
import actionTypes from '../action-types'
import callFetchApi from '../../services/api'
import commonService from '../../services/common-service'

const setAccessToken = () => {
  const accessToken = store.get('npipl_token_hash')
  return (
    {
      Authorization: `Bearer ${accessToken}`,
      AccessToken: accessToken,
      web_session: true
    }
  )
}
export function* addCustomerAddressSaga(action) {
  try {
    yield put({
        type: actionTypes.IS_ADDRESS_BEING_ADDED,
        payload: true,
    })
    const { url, data, customerId } = action.payload
    const response = yield call(callFetchApi, url.replace('$customerId', customerId), {}, 'POST', data, null, setAccessToken());
    if (response.status === 200 || response.status === 201) {
      yield put({
        type: actionTypes.UPDATE_CUSTOMER_ADDRESS,
        payload: response.data,
      })
      commonService.showNotification('success', 'Address added', 'Address added successfully')
    } else {
      commonService.showNotification('error', 'Unable to add address', 'Please try again later')
    }
    yield put({
        type: actionTypes.IS_ADDRESS_BEING_ADDED,
        payload: false,
    })
  } catch (error) {
    console.log('failed to add address')
    commonService.showNotification('error', 'Unable to add address', 'Please try again later')
    yield put({
        type: actionTypes.IS_ADDRESS_BEING_ADDED,
        payload: false,
    })
  }
}

export function* updateCustomerAddressSaga(action) {
  try {
    yield put({
        type: actionTypes.IS_ADDRESS_BEING_UPDATED,
        payload: true,
    })
    const { url, data, customerId } = action.payload
    const response = yield call(callFetchApi, url.replace('$customerId', customerId).replace('$addressId', data?.id), {}, 'PUT', data, null, setAccessToken())
    if (response.status === 200 || response.status === 201) {
      commonService.showNotification('success', 'Address updated', 'Address updated successfully')
      yield put({
        type: actionTypes.UPDATE_CUSTOMER_ADDRESS,
        payload: response.data,
      })
    } else {
      commonService.showNotification('error', 'Unable to update address', 'Please try again later')
    }
    yield put({
        type: actionTypes.IS_ADDRESS_BEING_UPDATED,
        payload: false,
    })
  } catch (error) {
    console.log('failed to update address')
    commonService.showNotification('error', 'Unable to update address', 'Please try again later')
    yield put({
        type: actionTypes.IS_ADDRESS_BEING_UPDATED,
        payload: false,
    })
  }
}

export function* removeCustomerAddressSaga(action) {
  try {
    yield put({
        type: actionTypes.IS_ADDRESS_BEING_REMOVED,
        payload: true,
    })
    const { url, customerId, addressId } = action.payload
    const response = yield call(callFetchApi, url.replace('$customerId', customerId).replace('$addressId', addressId), {}, 'DELETE', {}, null, setAccessToken())
    if (response.status === 200 || response.status === 201) {
      commonService.showNotification('success', 'Address removed', 'Address removed successfully')
      yield put({
        type: actionTypes.UPDATE_CUSTOMER_ADDRESS,
        payload: response.data,
      })
    } else {
      commonService.showNotification('error', 'Unable to remove address', 'Please try again later')
    }
    yield put({
        type: actionTypes.IS_ADDRESS_BEING_REMOVED,
        payload: false,
    })
  } catch (error) {
    console.log('failed to remvoe address')
    commonService.showNotification('error', 'Unable to remove address', 'Please try again later')
    yield put({
        type: actionTypes.IS_ADDRESS_BEING_REMOVED,
        payload: false,
    })
  }
}

export function* setDefaultAddressSaga(action) {
  try {
    yield put({
        type: actionTypes.IS_ADDRESS_BEING_UPDATED,
        payload: true,
    })
    const { url, addressId, customerId } = action.payload
    const response = yield call(callFetchApi, url.replace('$customerId', customerId).replace('$addressId', addressId), {}, 'PUT', {}, null, setAccessToken())
    if (response.status === 200 || response.status === 201) {
      commonService.showNotification('success', 'Updated default address', 'Default address updated successfully')
      yield put({
        type: actionTypes.UPDATE_CUSTOMER_ADDRESS,
        payload: response.data,
      })
    } else {
      commonService.showNotification('error', 'Unable to set default address', 'Please try again later')
    }
    yield put({
        type: actionTypes.IS_ADDRESS_BEING_UPDATED,
        payload: false,
    })
  } catch (error) {
    console.log('failed to update address')
    commonService.showNotification('error', 'Unable to set default address', 'Please try again later')
    yield put({
        type: actionTypes.IS_ADDRESS_BEING_UPDATED,
        payload: false,
    })
  }
}

export function* updateCustomerInfoSaga(action) {
  try {
    yield put({
        type: actionTypes.IS_CUSTOMER_INFO_BEING_UPDATED,
        payload: true,
    })
    const { url, data, customerId } = action.payload
    const response = yield call(callFetchApi, url.replace('$customerId', customerId), {}, 'PUT', data, null, setAccessToken())
    if (response.status === 200 || response.status === 201) {
      commonService.showNotification('success', 'Updated account details', 'Account details updated successfully')
      yield put({
        type: actionTypes.UPDATE_CUSTOMER_INFO,
        payload: response.data,
      })
    } else {
      commonService.showNotification('error', 'Unable to update account details', 'Please try again later')
    }
    yield put({
        type: actionTypes.IS_CUSTOMER_INFO_BEING_UPDATED,
        payload: false,
    })
    
  
  } catch (error) {
    console.log('failed to update customer info')
    commonService.showNotification('error', 'Unable to update account details', 'Please try again later')
    yield put({
        type: actionTypes.IS_CUSTOMER_INFO_BEING_UPDATED,
        payload: false,
    })
  }
}

function* watchRemoveCustomerAddressSaga() {
  yield takeLatest(actionTypes.REMOVE_CUSTOMER_ADDRESS, removeCustomerAddressSaga)
}

function* watchUpdateCustomerAddressSaga() {
  yield takeLatest(actionTypes.EDIT_CUSTOMER_ADDRESS, updateCustomerAddressSaga)
}

function* watchAddCustomerAddressSaga() {
  yield takeLatest(actionTypes.ADD_CUSTOMER_ADDRESS, addCustomerAddressSaga)
}

function* watchSetDefaultAddressSaga() {
  yield takeLatest(actionTypes.SET_DEFAULT_ADDRESS, setDefaultAddressSaga)
}

function* watchUpdateCustomerInfoSaga() {
  yield takeLatest(actionTypes.EDIT_CUSTOMER_INFO, updateCustomerInfoSaga)
}


export default function* newCustomerSagas() {
  yield all([
    fork(watchAddCustomerAddressSaga),
    fork(watchUpdateCustomerAddressSaga),
    fork(watchRemoveCustomerAddressSaga),
    fork(watchSetDefaultAddressSaga),
    fork(watchUpdateCustomerInfoSaga)
  ])
}
